import { SelectedMenu } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import ShelfDepth from 'rangeConfig/besta/widgets/ShelfDepth';
import { matchDepth, matchWidth } from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import removeOrganizersFromSelectedEntity from 'rangeConfig/besta/behaviors/removeOrganizersFromSelectedEntity';
import {
  matchCanHaveLight,
  matchShelfDepth
} from 'rangeConfig/besta/filters/selectedMenuProductFilters';
import { addProductToSelectedEntity } from 'rangeConfig/shared/behaviors/addProductToSelectedEntity';
import addOrReplaceAtTarget from 'rangeConfig/shared/behaviors/addOrReplaceAtTarget';
import removeTypeFromTarget from 'rangeConfig/shared/behaviors/removeTypeFromTarget';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeInterior',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: [
    { id: 'shelfDepth', component: ShelfDepth },
    {
      id: 'interiors-selected-menu-interiors',
      title: 'storageone.productListInteriorsTitle',
      cardsTitle: '',
      cardsSubtitle: 'typeName, designText',
      productThumbToolTip: 'typeName, designText',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [
        ProductType.BESTA_SHELF,
        ProductType.BESTA_GLASS_SHELF,
        ProductType.BESTA_BOTTLE_RACK
      ],
      productFilters: [matchWidth, matchDepth]
    },
    {
      id: 'interiors-selected-menu-lights',
      title: 'storageone.productListLightsTitle',
      cardsTitle: '',
      cardsSubtitle: 'typeName, designText',
      productThumbToolTip: 'typeName, designText',
      behaviors: {
        productClicked: [addOrReplaceAtTarget],
        productDropped: [addOrReplaceAtTarget]
      },
      productTypes: [ProductType.BESTA_INNER_LIGHT],
      productFilters: [matchCanHaveLight],
      noneOption: {
        behaviors: { removeProducts: [removeTypeFromTarget(ProductType.BESTA_INNER_LIGHT)] },
        selected: noProductsWithTypesForSelectedEntity([ProductType.BESTA_INNER_LIGHT]),
        title: 'storageone.productListNoInnerLightsOptionTitle'
      }
    },
    {
      id: 'interiors-selected-menu-organizers',
      title: 'storageone.selectedProductListAddOrganizers',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      behaviors: {
        productClicked: [addProductToSelectedEntity],
        productDropped: [addProductToSelectedEntity]
      },
      productTypes: [ProductType.BESTA_SHELF_ORGANIZER],
      productFilters: [matchShelfDepth],
      noneOption: {
        behaviors: { removeProducts: [removeOrganizersFromSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([ProductType.BESTA_SHELF_ORGANIZER]),
        title: 'storageone.productListNoShelfOrganisersOptionTitle'
      }
    }
  ]
};

export default selectedMenu;
